import { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { ShimmerThumbnail } from "react-shimmer-effects";
import Slider from '../../../components/Slider/custome_product';
import DetaileSection from '../../../components/DetailSection/custome_product';
import { Helmet } from 'react-helmet';
import { useNavigate, Link } from 'react-router-dom';

const mainUrl = process.env.REACT_APP_EXPRESS_APP_URL;

export default function Details({ item_id, getCartData }) {
    const [productData, setProductData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isDataValid, setIsDataValid] = useState(true);

    const navigate = useNavigate();

    const url = new URL(window.location.href);
    url.search = '';
    url.hash = '';
    const canonicalUrl = url.toString();

    useEffect(() => {
        if (!item_id) {
            setIsDataValid(false);
            setIsLoading(false);
            return;
        }

        const controller = new AbortController();

        const fetchProductDetails = async () => {
            setIsLoading(true);
            setIsDataValid(true);
            setProductData(null);

            try {
                const response = await axios.get(
                    `${mainUrl}/api/custom-products/${item_id}`,
                    { signal: controller.signal }
                );

                if (response.data?.success && response.data.data) {
                    setProductData(response.data.data);
                } else {
                    setIsDataValid(false);
                }
            } catch (error) {
                if (axios.isCancel(error)) return;
                console.error(error);
                setIsDataValid(false);
            } finally {
                if (!controller.signal.aborted) setIsLoading(false);
            }
        };

        fetchProductDetails();
        return () => controller.abort();
    }, [item_id]);

    const productArray = useMemo(
        () => (productData ? [productData] : []),
        [productData]
    );

    const ready = !isLoading && productData;

    return (
        <>
            <Helmet>
                <title>{productData?.product_name || 'Custom Product'}</title>
                <meta
                    name="description"
                    content={productData?.part_description || 'Custom Product'}
                />
                {/* <link rel="canonical" href={canonicalUrl} /> */}
            </Helmet>

            {isDataValid ? (
                <>
                    <section>
                        <div className="parformane-bar second-bar-p">
                            <div className="container">
                                <ul className="p-0 m-0 listing-parmofamne">
                                    <li><a href="/">Home / </a></li>
                                    <li><a href="/products/uncategorized/custom_products">Custom Products / </a></li>
                                    <li className="active-bread"><a href="#">{productData?.product_name}</a></li>
                                </ul>
                            </div>
                        </div>
                    </section>

                    <section className="slider-pernt">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    {ready ? (
                                        <Slider data={productArray} />
                                    ) : (
                                        <ShimmerThumbnail height={572} rounded />
                                    )}
                                </div>
                                <div className="col-lg-6">
                                    {ready ? (
                                        <DetaileSection data={productArray} setdata={getCartData} />
                                    ) : (
                                        <ShimmerThumbnail height={300} rounded />
                                    )}
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            ) : (
                <div className="error-screen text-center py-5">
                    <h1>Product Not Found</h1>
                    <p>Sorry, we couldn't find this custom product.</p>
                    <button className="btn btn-sm btn-danger" onClick={() => navigate('/')}>
                        Go back to homepage
                    </button>
                </div>
            )}
        </>
    );
}











// import { React, useState, useEffect } from 'react';
// import Slider from '../../../components/Slider/custome_product';
// import DetaileSection from '../../../components/DetailSection/custome_product';
// import axios from 'axios';
// import { ShimmerSocialPost, ShimmerThumbnail } from "react-shimmer-effects";
// import { Helmet } from 'react-helmet';

// export default function Details(prop) {
//   const mainUrl = process.env.REACT_APP_EXPRESS_APP_URL;
//   const currentLink = window.location.href;
//   const { item_id, getCartData } = prop;



//   const setdata = (value) => {
//     getCartData(value)
//   }

//   return (
//     <>
//       <Helmet>
//         <title>Custom Products</title>
//         <meta name="description" content="Custom Products" />
//         <link rel="canonical" href={currentLink} />
//       </Helmet>
//       <section>
//         <div className="parformane-bar second-bar-p">
//           <div className="container">
//             <ul className="p-0 m-0 listing-parmofamne">
//               <li><a href="/">Home /</a></li>
//               <li><a href="/products/uncategorized/custom_products">Custom Products /</a></li>
//               <li className='active-bread text-decoration-none'><a href="#">{item_id[0].product_name}</a></li>
//             </ul>
//           </div>
//         </div>
//       </section>
//       <section className="slider-pernt">
//         <div className='container'>
//           <div className="row">
//             <div className="col-lg-6">
//               <Slider data={item_id} />
//             </div>
//             <div className="col-lg-6">
//               <DetaileSection data={item_id} setdata={setdata} />
//             </div>
//           </div>
//         </div>
//       </section>

//     </>
//   )
// }
